export default __webpack_public_path__ + "static/atlas-support-d1bb8777ccb780146e71e3801fbb081e.svg";